// extracted by mini-css-extract-plugin
export default {"title":"pilih-kantor-marketing-pembeli_title__vwh7s"};